<style>
html {
  font-family: Tahoma;
  font-size: 14px;
}

.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #279947;
}
body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333;
}

.v-card > *:first-child:not(.v-btn):not(.v-chip) {
  border-top-left-radius: initial;
  border-top-right-radius: initial;
  border-block-end: initial;
}

.input-group-addon {
  background-color: white;
  border: 0px;
}

.vue-form-generator .form-control {
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid rgba(0, 0, 0, 0.54);
  border-radius: 0;
  font-family: "Roboto", sans-serif;
  font-size: 17px;
  padding: 0px;
  box-shadow: none;
}
.form-group label {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}
.form-group .valid .field-input .label {
  font-weight: 700;
  font-size: 8px;
  margin-bottom: 0px;
}

.vue-form-generator .field-switch input:checked ~ .label {
  background: #279947;
}
pre {
  overflow: auto;
}
pre .string {
  color: #885800;
}
pre .number {
  color: blue;
}
pre .boolean {
  color: magenta;
}
pre .null {
  color: red;
}
pre .key {
  color: green;
}

h1 {
  text-align: center;
  font-size: 36px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: 500;
}

.panel {
  border-color: #fff !important;
}

fieldset {
  border: 0;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 0px 1px rgba(0, 0, 0, 0.05);
  border-color: #ddd;
}

.panel-heading {
  color: #333;
  background-color: #f5f5f5;
  border-color: #ddd;

  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.panel-body {
  padding: 0px;
}

.field-checklist .wrapper {
  width: 100%;
}

.select option {
  background: #279947;
}
</style>

<template>
  <div>
    <form>
      <div class="alignment" id="app">
        <!-- <h3 class="styleHeader"> <var Title="title"> </h3> -->
        <h3 class="styleHeader">{{ this.title }}</h3>
        <v-card class="styleDataTable styleHeader">
          <customerComponent
            v-on:customerChange="custChanged"
            ref="customerComponent"
          ></customerComponent>
        </v-card>

        <v-card class="styleDataTable">
          <div class="panel panel-default">

            <div v-for="(n,i) in cmpClientsCount" :key="i">
              <v-select
                v-if = "showSelectClient"
                v-model="customer_list[i]"
                :items="customers"
                :label="$t('pages.Order.Create.Cliente')"
                autocomplete
                required
                item-text="ragsoc"
                item-value="codcli"
                @input.native="OnChangeClient($event)"
              ></v-select>
            </div>
            
            <!-- <div class="panel-heading">Form</div> -->
            <div class="panel-body">
              <vue-form-generator
                :schema="schema1"
                :model="model1"
                :options="formOptions"
              ></vue-form-generator>
            </div>
          </div>
        </v-card>
      </div>
    </form>

    <div class="alignment" style="margin-top: -60px">
      <v-btn
        class="white--text styleAlignementSaveButton styleHeaderTop styleHeader"
        @click="submit"
        :disabled="submitDisabled"
        color="#279947"
      >
        {{ $t("pages.Extractions.View.Esegui") }}
      </v-btn>
      <v-card>
        <div v-show="showGrid">
          <fercam-kendogrid
            controller="Extractions/"
            readAll="ExecuteQuery"
            :CanCreate="false"
            :disableEdit="true"
            :disableDelete="true"
            :hideColumns="['RowNum']"
            :refresh="forceRefresh"
            :payload="this.message"
            edit="Create"
            :customFilters="customFilters"
          ></fercam-kendogrid>
          <!-- <Grid
            controller="Extractions/"
            readAll="ExecuteQuery"
            :CanCreate="false"
            :disableEdit="true"
            :disableDelete="true"
            :hideColumns="['RowNum']"
            :refresh="forceRefresh"
            :payload="this.message"
            edit="Create"
            :customFilters="customFilters"
          />-->
        </div>
      </v-card>
    </div>
    <v-alert
      :value="errorAlert"
      type="error"
      style="bottom: -5px;position: fixed;width: 100%;"
    >
      {{ errorAlertMessage }}
    </v-alert>
  </div>
</template>
<script>
import extractionApi from "../../apiSmartLogistics/extractionApi.js";
import customerComponent from "../../Components/CustomersComponent.vue";
import VueFormGenerator from "vue-form-generator";
import debounce from "debounce";
import "vue-form-generator/dist/vfg.css";
import insertOrderApi from "../../apiSmartLogistics/InsertOrderApi.js";
//import jQuery from 'jQuery'
//npm i bootstrap jquery popper.js
//import 'bootstrap';
//import jquery from 'jquery';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '../../css/bootstrap-datetimepicker.min.css'
// import '../../css/bootstrap.min.css'
// import * as b from '../../script/bootstrap-datetimepicker.min.js'
// import * as c from '../../script/bootstrap.min.js'
// import * as d from '../../script/jquery.min.js'
// import * as e from '../../script/moment.min.js'

export default {
  components: {
    "vue-form-generator": VueFormGenerator.component,
    customerComponent
  },

  data() {
    return {
      model1: {},
      schema1: {
        fields: []
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true
      },
      customerSelected: "",
      message: {},
      forceRefresh: false,
      customFilters: [],
      showGrid: false,
      submitDisabled: true,
      title: "",
      errorAlert: false,
      errorAlertMessage: "",
      showSelectClient: false,
      customer: "",
      customers: [],
      cmpClientsCount: 0,
      customer_list: []
    };
  },

  methods: {

    OnChangeClient: debounce(function(event) {
    if (event.target.value.length > 2) {
        let searchItem = {
          searchKey: event.target.value,
          id: this.customerSelected,
        };

        insertOrderApi
        .GetClientsSearch(searchItem)
        .then(({ data }) => {
          this.errorAlert = false;
          this.customers = data;
          event.target.value = data;
        })
        .catch(message => {
          this.errorAlert = true;
          this.errorAlertMessage = message.message;
        });
      }
    }, 200),
    
    custChanged(customerSelected) {
      this.customerSelected = customerSelected;
      this.StartGetExtractions();
      this.submitDisabled = false;
    },
    getExtractions() {
      extractionApi.GetExtractions().then(response => {
        this.extractions = response.data;
      });
    },
    submit() {
      //console.log("model ", this.model1);
      //let j = JSON.stringify(this.model1);
      //console.log("json ", j);

      if(this.cmpClientsCount > 0){
        this.insertCmpClientsData();
      }

      this.message = {
        extractionId: this.$route.params.id,
        customerId: this.customerSelected,
        queryArgs: this.model1
      };

      if (this.forceRefresh == undefined) {
        this.forceRefresh = true;
      }
      this.forceRefresh = !this.forceRefresh;
      this.showGrid = true;
    },

    checkStringQueryCustom(str) {
      //ricerco elementi di tipo cmp_text
      var findCmpText = /cmp_text/gi,
        result,
        indices = [];
      //ricerco elementi in posizione

      let index = 0;
      //let obj = {};
      //cerco elementi di tipo findCmpText
      while ((result = findCmpText.exec(str))) {
        let label = str.substring(
          str.indexOf('"', result.index) + 1,
          str.indexOf('"', str.indexOf('"', result.index) + 1)
        );

        indices.push(result.index);

        let fieldname = "cmp_text" + index;
        this.model1[fieldname] = "";

        let f = {
          type: "input",
          inputType: "text",
          label: label,
          model: fieldname,
          readonly: false,
          featured: false,
          disabled: false
        };
        this.schema1.fields.push(f);
        index++;
      }
    },

    createCmpCheck(str) {
      //ricerco elementi di tipo cmp_text
      var findElement = /cmp_check/gi,
        result,
        indices = [];
      //ricerco elementi in posizione

      let index = 0;
      //cerco elementi di tipo findCmpText
      while ((result = findElement.exec(str))) {
        //ricerco in questa posizione il valore tra gli apici
        let label = str.substring(
          str.indexOf('"', result.index) + 1,
          str.indexOf('"', str.indexOf('"', result.index) + 1)
        );

        indices.push(result.index);

        let fieldname = "cmp_check" + index;
        this.model1[fieldname] = "";

        let f = {
          type: "switch",
          label: label,
          model: fieldname,
          multi: true,
          readonly: false,
          featured: false,
          disabled: false,
          default: true,
          textOn: "Active",
          textOff: "Inactive"
        };
        this.schema1.fields.push(f);
        index++;
      }
    },

    createCmpDatetime(str) {
      //ricerco elementi di tipo cmp_text
      var findElement = /cmp_datetime/gi,
        result,
        indices = [];
      //ricerco elementi in posizione

      let index = 0;
      //let obj = {};
      //cerco elementi di tipo findCmpText
      while ((result = findElement.exec(str))) {
        //ricerco in questa posizione il valore tra gli apici
        let label = str.substring(
          str.indexOf('"', result.index) + 1,
          str.indexOf('"', str.indexOf('"', result.index) + 1)
        );

        indices.push(result.index);

        // from
        let fieldname = "cmp_datetime_from" + index;
        this.model1[fieldname] = null;

        var today = new Date;
        var time = today.getDate() + "/" + (today.getMonth()+1) + "/" + today.getFullYear();

        let f_from = {
          type: "dateTimePicker",
          label: label + " da",
          model: fieldname,
          required: false,
          placeholder: time,

          dateTimePickerOptions: {
            format: "DD/MM/YYYY"
          }
        };
        this.schema1.fields.push(f_from);

        // to
        fieldname = "cmp_datetime_to" + index;
        this.model1[fieldname] = null;

        let f_to = {
          type: "dateTimePicker",
          label: "a",
          model: fieldname,
          required: false,
          placeholder: time,

          dateTimePickerOptions: {
            format: "DD/MM/YYYY"
          }
        };

        this.schema1.fields.push(f_to);

        index++;
      }
    },

    createCmpClients(str) {
      //ricerco elementi di tipo cmp_text
      var findElement = /cmp_clients/gi,
        result,
        indices = [];
      //ricerco elementi in posizione

      let index = 0;

      //cerco elementi di tipo findCmpText
      while ((result = findElement.exec(str))) {
        //ricerco in questa posizione il valore tra gli apici

        let label = str.substring(
          str.indexOf('"', result.index) + 1,
          str.indexOf('"', str.indexOf('"', result.index) + 1)
        );

        indices.push(result.index);

        // from
        let fieldname = "cmp_clients" + index;
        this.model1[fieldname] = null;

        let f = {
          type: "select",
          label: label,
          model: fieldname,
          values: this.customers,
          selectOptions: { value: "codcli", name: "ragsoc" }
        };
        this.schema1.fields.push(f);

        index++;
      }
    },

    createCmpDropdown(str) {
      //ricerco elementi di tipo cmp_text
      var findElement = /cmp_dropdown/gi,
        result,
        indices = [];
      //ricerco elementi in posizione

      let index = 0;
      //let obj = {};
      //cerco elementi di tipo findCmpText
      while ((result = findElement.exec(str))) {
        //ricerco in questa posizione il valore tra gli apici

        let label = str.substring(
          str.indexOf('"', result.index) + 1,
          str.indexOf('"', str.indexOf('"', result.index) + 1)
        );

        let options_obj = [];
        let options = str.substring(
          str.indexOf('"', str.indexOf('"', result.index) + 1),
          str.indexOf("]", str.indexOf('"', str.indexOf('"', result.index) + 1))
        );
        let options_array = options.replace(/['"]+/g, "").split(",");

        options_array.forEach(function(entry) {
          if (entry) {
            let option_array = entry.split(";");
            let name = option_array[0];
            let value = option_array[1];

            let myobj = {};
            myobj["id"] = value;
            myobj["name"] = name;
            options_obj.push(myobj);
          }
        });

        indices.push(result.index);

        // from
        let fieldname = "cmp_dropdown" + index;
        this.model1[fieldname] = null;

        let f = {
          type: "select",
          label: label,
          model: fieldname,

          values: function() {
            return options_obj;
          }
        };

        this.schema1.fields.push(f);

        index++;
      }
    },

    getExtraction(id) {

      extractionApi.GetExtraction(id).then(response => {
        var findElement = /cmp_clients/gi,
        result,
        indices = [];

        while((result = findElement.exec(response.data.queryCustom))){
          this.showSelectClient = true;
        }

        this.checkStringQueryCustom(response.data.queryCustom);
        this.createCmpCheck(response.data.queryCustom);
        this.createCmpDatetime(response.data.queryCustom);    
        this.createCmpDropdown(response.data.queryCustom);
      });
    },

    StartGetExtractions(){
          let id = this.$route.params.id;
          this.schema1.fields = [];
          this.model1 = {};
          this.getExtraction(id);
          this.CountCmpClients(id);
    },

    CountCmpClients(id){
      extractionApi.GetExtraction(id).then(response => {
      var str = response.data.queryCustom;
      
      this.cmpClientsCount = (str.split("cmp_clients").length - 1);
    });
    },

    insertCmpClientsData(){
      for (var i = 0; i < this.cmpClientsCount; i++) {
        var label = "cmp_clients"+i;
        this.model1[label] = (this.customer_list[i] == undefined)? "" : this.customer_list[i];
      }
    }
  },

  created() {
    let id = this.$route.params.id;
    extractionApi.GetExtraction(id).then(response => {
      this.title = response.data.name;
    });
  }
};
</script>
